import {useSelector} from 'react-redux';

import {VISTA_PLUS} from 'constants/success';
import {useCheckIfExamExists} from 'desktop/pages/success/hooks/useCheckIfExamExists';
import {getDrawerState} from 'desktop/pages/success/selectorsV2';

import {getOrderItems} from 'desktop/pages/success/store/selectors/orderStatus/orderStatus';
import {getIsEyeExamVisible} from 'libs/success/helpers/helpers';

import {getPopupType} from 'libs/success/prescriptionPopup/prescriptionPopup';

import {getPrescriptionStatusAfterUpdateOrder} from 'libs/success/statuses/statuses';

import {OrderDetailsItemsType} from 'types/orderDetailsTypes';

/**
 * Hook to handle side effects for the drawer screen in the contacts section
 */
export const useDrawerScreenSideEffects = () => {
    const {item} = useSelector(getDrawerState);
    const items = useSelector(getOrderItems);
    const shouldShowEyeExam = getIsEyeExamVisible(items);
    const {isAnyExamExist} = useCheckIfExamExists();
    const product = item?.product;
    const isVista = product?.brand.name === VISTA_PLUS;
    const updatedItemStatus = getPrescriptionStatusAfterUpdateOrder(
        items,
        item as OrderDetailsItemsType,
    );

    const type = getPopupType(item, updatedItemStatus);

    return {
        isAnyExamExist,
        isVista,
        item,
        product,
        shouldShowEyeExam,
        type,
        updatedItemStatus,
    };
};
